import CityPageTemplate from "../city-template/CityPageTemplate";
import { bloomingtonConfig } from "./data";

export default function BloomingtonInPage() {
  return <CityPageTemplate config={bloomingtonConfig} />;
}